var data = {
    redir_url: "",
    factor: 60,
    inflate_factor: 5,
    margin: 36,
    scale: 36,
    convertion_factor: 0.3048,
    defaul_dimentions: { imperial: { measure: 16, min: 4, max: 125, step: 4 }, metric: { measure: 4.8768, min: 1.22, max: 40.48, step: 1.22 }, centimeter: { measure: 487.68, min: 122, max: 4048, step: 122 }, inches: { measure: 192, min: 48.0315, max: 1593.7008, step: 48.0315 } },
    patterns: {
        solid: { text: "Solid", img: siteURL + "img/patterns/solid.png" },
        checkered: { text: "Checkered", img: siteURL + "img/patterns/checkered.png" },
        square: { text: "Square", img: siteURL + "img/patterns/square.png" },
        square_checkered: { text: "Square Checkered", img: siteURL + "img/patterns/square_checkered.png" },
        swedish: { text: "Swedish", img: siteURL + "img/patterns/swedish.png" },
        big_checkers: { text: "Big Checkers", img: siteURL + "img/patterns/big_checkers.png" },
        double_square: { text: "Double Square", img: siteURL + "img/patterns/double_square.png" },
    },
    colors: { drawing_area: "#000000", general_fill: "#cccccc", tile_stroke: "#000000", measure: "#1F1F14", none_tile_border: "#cccccc", none_tile_fill: "#ffffff" },
    img: { right_arrow: siteURL + "/horizontal.svg", down_arrow: siteURL + "/vertical.svg", diagonal_arrow: siteURL + "/diagonal.svg", back_square: siteURL + "back_square.png" },
    text: { all_types: { font: "16px Arial", color: "#e00025" }, measures: { font: "16px Arial", fontweight: "bold", color: "#e00025" }, drag: { font: "14px Arial", color: "#020202" } },
    none_tile_area: {
        points: { 0: { x: 1, y: 0 }, 1: { x: 1, y: 1 }, 2: { x: 0, y: 1 }, 3: { x: 0, y: 0 } },
        drags: {
            type: "xy",
            location: { position: "center", points: [1] },
            points: { 0: ["x"], 1: ["x", "y"], 2: ["y"] },
            limits: [
                { point: 3, axis: "x", not: "under" },
                { point: 3, axis: "y", not: "under" },
            ],
        },
    },
    types: {
        rectangle: {
            label: { text: "Square / Rectangular shape", x: 1, y: 4.5 },
            type: "rectangle",
            start_point: { x: 150, y: 50 },
            points: { 0: { x: 4, y: 0, angle: 3 }, 1: { x: 4, y: 0 }, 2: { x: 4, y: 4, angle: 0 }, 3: { x: 4, y: 4 }, 4: { x: 0, y: 4, angle: 1 }, 5: { x: 0, y: 4 }, 6: { x: 0, y: 0, angle: 2 }, 7: { x: 0, y: 0 } },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 6, axis: "y", not: "under" },
                                { point: 7, axis: "x", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "left_under", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [{ axis: "x", start: 7, finish: 0, side: "A", readonly: !1, index: 0 }],
                1: [{ axis: "y", start: 1, finish: 2, side: "B", readonly: !1, index: 1 }],
                2: [{ axis: "x", start: 3, finish: 4, side: "C", readonly: !1, index: 2 }],
                3: [{ axis: "y", start: 5, finish: 6, side: "D", readonly: !1, index: 3 }],
            },
        },
        tl_l_shape: {
            label: { text: "TL - L Shape", x: 1, y: 4.5 },
            type: "tl_l_shape",
            start_point: { x: 400, y: 50 },
            points: {
                0: { x: 4, y: 0, angle: 3 },
                1: { x: 4, y: 0 },
                2: { x: 4, y: 2, angle: 0 },
                3: { x: 4, y: 2 },
                4: { x: 2, y: 2 },
                5: { x: 2, y: 2 },
                6: { x: 2, y: 4, angle: 0 },
                7: { x: 2, y: 4 },
                8: { x: 0, y: 4, angle: 1 },
                9: { x: 0, y: 4 },
                10: { x: 0, y: 0, angle: 2 },
                11: { x: 0, y: 0 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 6, axis: "x", not: "under" },
                                { point: 6, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "left_under", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [6] },
                            points: { 4: ["x"], 5: ["x"], 6: ["x", "y"], 7: ["x", "y"], 8: ["y"], 9: ["y"] },
                            limits: [
                                { point: 3, axis: "x", not: "over" },
                                { point: 3, axis: "y", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [{ axis: "x", start: 11, finish: 0, side: "A", readonly: !1, calculate_with: "", index: 0 }],
                1: [
                    { axis: "y", start: 1, finish: 2, side: "B", readonly: !1, calculate_with: "C", index: 1 },
                    { axis: "y", start: 5, finish: 6, side: "C", readonly: !1, calculate_with: "B", index: 1 },
                ],
                2: [
                    { axis: "x", start: 3, finish: 4, side: "D", readonly: !1, calculate_with: "E", index: 2 },
                    { axis: "x", start: 7, finish: 8, side: "E", readonly: !1, calculate_with: "D", index: 2 },
                ],
                3: [{ axis: "y", start: 9, finish: 10, side: "F", readonly: !1, calculate_with: "", index: 3 }],
            },
        },
        tr_l_shape: {
            label: { text: "TR - L Shape", x: 1, y: 4.5 },
            type: "tr_l_shape",
            start_point: { x: 650, y: 50 },
            points: {
                0: { x: 4, y: 0, angle: 3 },
                1: { x: 4, y: 0 },
                2: { x: 4, y: 4, angle: 0 },
                3: { x: 4, y: 4 },
                4: { x: 2, y: 4, angle: 1 },
                5: { x: 2, y: 4, outer: !0 },
                6: { x: 2, y: 2 },
                7: { x: 2, y: 2 },
                8: { x: 0, y: 2, angle: 1 },
                9: { x: 0, y: 2 },
                10: { x: 0, y: 0, angle: 2 },
                11: { x: 0, y: 0 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 7, axis: "x", not: "under" },
                                { point: 7, axis: "y", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "left_under", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [6] },
                            points: { 4: ["x"], 5: ["x"], 6: ["x", "y"], 7: ["x", "y"], 8: ["y"], 9: ["y"] },
                            limits: [
                                { point: 3, axis: "x", not: "over" },
                                { point: 3, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [{ axis: "x", start: 11, finish: 0, side: "A", readonly: !1, calculate_with: "", index: 0 }],
                1: [{ axis: "y", start: 1, finish: 2, side: "B", readonly: !1, calculate_with: "", index: 1 }],
                2: [
                    { axis: "x", start: 3, finish: 4, side: "C", readonly: !1, calculate_with: "D", index: 2 },
                    { axis: "x", start: 7, finish: 8, side: "D", readonly: !1, calculate_with: "C", index: 2 },
                ],
                3: [
                    { axis: "y", start: 5, finish: 6, side: "E", readonly: !1, calculate_with: "F", index: 3 },
                    { axis: "y", start: 9, finish: 10, side: "F", readonly: !1, calculate_with: "E", index: 3 },
                ],
            },
        },
        bl_l_shape: {
            label: { text: "BL - L Shape", x: 1, y: 4.5 },
            type: "bl_l_shape",
            start_point: { x: 400, y: 50 },
            points: {
                0: { x: 2, y: 0, angle: 3 },
                1: { x: 2, y: 0 },
                2: { x: 2, y: 2 },
                3: { x: 2, y: 2, outer: !0 },
                4: { x: 4, y: 2, angle: 3 },
                5: { x: 4, y: 2 },
                6: { x: 4, y: 4, angle: 0 },
                7: { x: 4, y: 4 },
                8: { x: 0, y: 4, angle: 1 },
                9: { x: 0, y: 4 },
                10: { x: 0, y: 0, angle: 2 },
                11: { x: 0, y: 0 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 6, axis: "x", not: "over" },
                                { point: 6, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "left_under", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [6] },
                            points: { 4: ["x"], 5: ["x"], 6: ["x", "y"], 7: ["x", "y"], 8: ["y"], 9: ["y"] },
                            limits: [
                                { point: 3, axis: "x", not: "under" },
                                { point: 3, axis: "y", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [
                    { axis: "x", start: 11, finish: 0, side: "A", readonly: !1, calculate_with: "B", index: 0 },
                    { axis: "x", start: 3, finish: 4, side: "B", readonly: !1, calculate_with: "A", index: 0 },
                ],
                1: [
                    { axis: "y", start: 1, finish: 2, side: "C", readonly: !1, calculate_with: "D", index: 1 },
                    { axis: "y", start: 5, finish: 6, side: "D", readonly: !1, calculate_with: "C", index: 1 },
                ],
                2: [{ axis: "x", start: 7, finish: 8, side: "E", readonly: !1, calculate_with: "", index: 2 }],
                3: [{ axis: "y", start: 9, finish: 10, side: "F", readonly: !1, calculate_with: "", index: 3 }],
            },
        },
        br_l_shape: {
            label: { text: "BR - L Shape", x: 1, y: 4.5 },
            type: "br_l_shape",
            start_point: { x: 400, y: 50 },
            points: {
                0: { x: 2, y: 0, angle: 2 },
                1: { x: 2, y: 0, outer: !0 },
                2: { x: 2, y: 2 },
                3: { x: 2, y: 2, outer: !0 },
                4: { x: 0, y: 2, angle: 2 },
                5: { x: 0, y: 2 },
                6: { x: 0, y: 4, angle: 1 },
                7: { x: 0, y: 4 },
                8: { x: 4, y: 4, angle: 0 },
                9: { x: 4, y: 4 },
                10: { x: 4, y: 0, angle: 3 },
                11: { x: 4, y: 0 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 8, axis: "x", not: "over" },
                                { point: 8, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "left_under", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [8] },
                            points: { 6: ["y"], 7: ["y"], 8: ["x", "y"], 9: ["x", "y"], 10: ["x"], 11: ["x"] },
                            limits: [
                                { point: 2, axis: "x", not: "under" },
                                { point: 2, axis: "y", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 8 }, axis: "y", start: 7, finish: 8 },
                                { location: { position: "left_under", point: 9 }, axis: "x", start: 9, finish: 10 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [
                    { axis: "x", start: 0, finish: 11, side: "B", readonly: !1 },
                    { axis: "x", start: 4, finish: 3, side: "A", readonly: !1 },
                ],
                1: [{ axis: "y", start: 10, finish: 9, side: "C", readonly: !1 }],
                2: [{ axis: "x", start: 8, finish: 7, side: "D", readonly: !1 }],
                3: [
                    { axis: "y", start: 2, finish: 1, side: "F", readonly: !1 },
                    { axis: "y", start: 6, finish: 5, side: "E", readonly: !1 },
                ],
            },
        },
        l_t_shape: {
            label: { text: "Left - T Shape", x: 1, y: 4.5 },
            type: "l_t_shape",
            start_point: { x: 650, y: 50 },
            points: {
                0: { x: 2, y: 0, angle: 3 },
                1: { x: 2, y: 0 },
                2: { x: 2, y: 1 },
                3: { x: 2, y: 1, outer: !0 },
                4: { x: 4, y: 1, angle: 3 },
                5: { x: 4, y: 1 },
                6: { x: 4, y: 3, angle: 0 },
                7: { x: 4, y: 3 },
                8: { x: 2, y: 3 },
                9: { x: 2, y: 3 },
                10: { x: 2, y: 4, angle: 0 },
                11: { x: 2, y: 4 },
                12: { x: 0, y: 4, angle: 1 },
                13: { x: 0, y: 4 },
                14: { x: 0, y: 0, angle: 2 },
                15: { x: 0, y: 0 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 6, axis: "y", not: "over" },
                                { point: 7, axis: "x", not: "over" },
                            ],
                            measures: [
                                { location: { position: "left_under", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "right_over", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [6] },
                            points: { 4: ["x"], 5: ["x"], 6: ["x", "y"], 7: ["x", "y"], 8: ["y"], 9: ["y"] },
                            limits: [
                                { point: 2, axis: "y", not: "under" },
                                { point: 10, axis: "y", not: "over" },
                                { point: 10, axis: "x", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [10] },
                            points: { 8: ["x"], 9: ["x"], 10: ["x", "y"], 11: ["x", "y"], 12: ["y"], 13: ["y"] },
                            limits: [
                                { point: 6, axis: "x", not: "over" },
                                { point: 6, axis: "y", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 10 }, axis: "y", start: 9, finish: 10 },
                                { location: { position: "left_under", point: 11 }, axis: "x", start: 11, finish: 12 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [
                    { axis: "x", start: 15, finish: 0, side: "A", readonly: !1, calculate_with: "B", index: 0 },
                    { axis: "x", start: 3, finish: 4, side: "B", readonly: !1, calculate_with: "A", index: 0 },
                ],
                1: [
                    { axis: "y", start: 1, finish: 2, side: "C", readonly: !1, calculate_with: "D", index: 1 },
                    { axis: "y", start: 5, finish: 6, side: "D", readonly: !1, calculate_with: "C", index: 1 },
                    { axis: "y", start: 9, finish: 10, side: "E", readonly: !1, calculate_with: "D", index: 1 },
                ],
                2: [
                    { axis: "x", start: 7, finish: 8, side: "F", readonly: !1, calculate_with: "G", index: 2 },
                    { axis: "x", start: 11, finish: 12, side: "G", readonly: !1, calculate_with: "F", index: 2 },
                ],
                3: [{ axis: "y", start: 13, finish: 14, side: "H", readonly: !1, calculate_with: "", index: 3 }],
            },
        },
        t_t_shape: {
            label: { text: "Top - T Shape", x: 1, y: 4.5 },
            type: "t_t_shape",
            start_point: { x: 650, y: 50 },
            points: {
                0: { x: 4, y: 0, angle: 3 },
                1: { x: 4, y: 0 },
                2: { x: 4, y: 2, angle: 0 },
                3: { x: 4, y: 2 },
                4: { x: 3, y: 2 },
                5: { x: 3, y: 2 },
                6: { x: 3, y: 4, angle: 0 },
                7: { x: 3, y: 4 },
                8: { x: 1, y: 4, angle: 1 },
                9: { x: 1, y: 4, outer: !0 },
                10: { x: 1, y: 2 },
                11: { x: 1, y: 2 },
                12: { x: 0, y: 2, angle: 1 },
                13: { x: 0, y: 2 },
                14: { x: 0, y: 0, angle: 2 },
                15: { x: 0, y: 0 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["x"], 1: ["x"], 2: ["x", "y"], 3: ["x", "y"], 4: ["y"], 5: ["y"] },
                            limits: [
                                { point: 6, axis: "y", not: "over" },
                                { point: 7, axis: "x", not: "under" },
                            ],
                            measures: [
                                { location: { position: "left_under", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "right_over", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [6] },
                            points: { 4: ["x"], 5: ["x"], 6: ["x", "y"], 7: ["x", "y"], 8: ["y"], 9: ["y"] },
                            limits: [
                                { point: 2, axis: "y", not: "under" },
                                { point: 10, axis: "y", not: "under" },
                                { point: 2, axis: "x", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [10] },
                            points: { 8: ["x"], 9: ["x"], 10: ["x", "y"], 11: ["x", "y"], 12: ["y"], 13: ["y"] },
                            limits: [
                                { point: 6, axis: "x", not: "over" },
                                { point: 6, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 10 }, axis: "y", start: 9, finish: 10 },
                                { location: { position: "left_under", point: 11 }, axis: "x", start: 11, finish: 12 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [{ axis: "x", start: 15, finish: 0, side: "A", readonly: !1, calculate_with: "", index: 0 }],
                1: [
                    { axis: "y", start: 1, finish: 2, side: "B", readonly: !1, calculate_with: "C", index: 1 },
                    { axis: "y", start: 5, finish: 6, side: "C", readonly: !1, calculate_with: "B", index: 1 },
                ],
                2: [
                    { axis: "x", start: 3, finish: 4, side: "D", readonly: !1, calculate_with: "E", index: 2 },
                    { axis: "x", start: 7, finish: 8, side: "E", readonly: !1, calculate_with: "D", index: 2 },
                    { axis: "x", start: 11, finish: 12, side: "F", readonly: !1, calculate_with: "E", index: 2 },
                ],
                3: [
                    { axis: "y", start: 13, finish: 14, side: "H", readonly: !1, calculate_with: "G", index: 3 },
                    { axis: "y", start: 9, finish: 10, side: "G", readonly: !1, calculate_with: "H", index: 3 },
                ],
            },
        },
        r_t_shape: {
            label: { text: "Right - T Shape", x: 1, y: 4.5 },
            type: "r_t_shape",
            start_point: { x: 650, y: 50 },
            points: {
                0: { x: 0, y: 3, angle: 1 },
                1: { x: 0, y: 3 },
                2: { x: 2, y: 3 },
                3: { x: 2, y: 3, outer: !0 },
                4: { x: 2, y: 4, angle: 1 },
                5: { x: 2, y: 4 },
                6: { x: 4, y: 4, angle: 0 },
                7: { x: 4, y: 4 },
                8: { x: 4, y: 0, angle: 3 },
                9: { x: 4, y: 0 },
                10: { x: 2, y: 0, angle: 2 },
                11: { x: 2, y: 0, outer: !0 },
                12: { x: 2, y: 1 },
                13: { x: 2, y: 1, outer: !0 },
                14: { x: 0, y: 1, angle: 2 },
                15: { x: 0, y: 1 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["y"], 1: ["y"], 2: ["x", "y"], 3: ["x", "y"], 4: ["x"], 5: ["x"] },
                            limits: [
                                { point: 12, axis: "y", not: "under" },
                                { point: 6, axis: "x", not: "over" },
                            ],
                            measures: [
                                { location: { position: "left_under", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "right_over", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [6] },
                            points: { 4: ["y"], 5: ["y"], 6: ["x", "y"], 7: ["x", "y"], 8: ["x"], 9: ["x"] },
                            limits: [
                                { point: 2, axis: "y", not: "under" },
                                { point: 2, axis: "y", not: "under" },
                                { point: 12, axis: "x", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [12] },
                            points: { 10: ["x"], 11: ["x"], 12: ["x", "y"], 13: ["x", "y"], 14: ["y"], 15: ["y"] },
                            limits: [
                                { point: 6, axis: "x", not: "over" },
                                { point: 2, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 10 }, axis: "y", start: 9, finish: 10 },
                                { location: { position: "left_under", point: 11 }, axis: "x", start: 11, finish: 12 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [
                    { axis: "x", start: 14, finish: 13, side: "A", readonly: !1, calculate_with: "B", index: 0 },
                    { axis: "x", start: 10, finish: 9, side: "B", readonly: !1, calculate_with: "A", index: 0 },
                ],
                1: [{ axis: "y", start: 8, finish: 7, side: "C", readonly: !1, calculate_with: "", index: 1 }],
                2: [
                    { axis: "x", start: 2, finish: 1, side: "D", readonly: !1, calculate_with: "E", index: 2 },
                    { axis: "x", start: 6, finish: 5, side: "E", readonly: !1, calculate_with: "D", index: 2 },
                ],
                3: [
                    { axis: "y", start: 12, finish: 11, side: "F", readonly: !1, calculate_with: "G", index: 3 },
                    { axis: "y", start: 0, finish: 15, side: "G", readonly: !1, calculate_with: "F", index: 3 },
                    { axis: "y", start: 4, finish: 3, side: "H", readonly: !1, calculate_with: "G", index: 3 },
                ],
            },
        },
        b_t_shape: {
            label: { text: "Bottom - T Shape", x: 1, y: 4.5 },
            type: "b_t_shape",
            start_point: { x: 650, y: 50 },
            points: {
                0: { x: 0, y: 2, angle: 2 },
                1: { x: 0, y: 2, outer: !0 },
                2: { x: 1, y: 2 },
                3: { x: 1, y: 2, outer: !0 },
                4: { x: 1, y: 0, angle: 2 },
                5: { x: 1, y: 0 },
                6: { x: 3, y: 0, angle: 3 },
                7: { x: 3, y: 0 },
                8: { x: 3, y: 2 },
                9: { x: 3, y: 2, outer: !0 },
                10: { x: 4, y: 2, angle: 3 },
                11: { x: 4, y: 2 },
                12: { x: 4, y: 4, angle: 0 },
                13: { x: 4, y: 4 },
                14: { x: 0, y: 4, angle: 1 },
                15: { x: 0, y: 4 },
            },
            drags: {
                step2: {
                    buttons: [],
                    points: [
                        {
                            type: "xy",
                            location: { position: "center", points: [2] },
                            points: { 0: ["y"], 1: ["y"], 2: ["x", "y"], 3: ["x", "y"], 4: ["x"], 5: ["x"] },
                            limits: [
                                { point: 12, axis: "y", not: "over" },
                                { point: 8, axis: "x", not: "over" },
                            ],
                            measures: [
                                { location: { position: "left_under", point: 2 }, axis: "y", start: 1, finish: 2 },
                                { location: { position: "right_over", point: 3 }, axis: "x", start: 3, finish: 4 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [8] },
                            points: { 6: ["x"], 7: ["x"], 8: ["x", "y"], 9: ["x", "y"], 10: ["y"], 11: ["y"] },
                            limits: [
                                { point: 12, axis: "x", not: "over" },
                                { point: 2, axis: "x", not: "under" },
                                { point: 12, axis: "y", not: "over" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 6 }, axis: "y", start: 5, finish: 6 },
                                { location: { position: "left_under", point: 7 }, axis: "x", start: 7, finish: 8 },
                            ],
                        },
                        {
                            type: "xy",
                            location: { position: "center", points: [12] },
                            points: { 10: ["x"], 11: ["x"], 12: ["x", "y"], 13: ["x", "y"], 14: ["y"], 15: ["y"] },
                            limits: [
                                { point: 8, axis: "x", not: "under" },
                                { point: 8, axis: "y", not: "under" },
                                { point: 2, axis: "y", not: "under" },
                            ],
                            measures: [
                                { location: { position: "right_over", point: 10 }, axis: "y", start: 9, finish: 10 },
                                { location: { position: "left_under", point: 11 }, axis: "x", start: 11, finish: 12 },
                            ],
                        },
                    ],
                },
                step3: {
                },
            },
            measures: {
                0: [
                    { axis: "x", start: 1, finish: 2, side: "A", readonly: !1, calculate_with: "B", index: 3 },
                    { axis: "x", start: 5, finish: 6, side: "B", readonly: !1, calculate_with: "A", index: 3 },
                    { axis: "x", start: 9, finish: 10, side: "C", readonly: !1, calculate_with: "B", index: 3 },
                ],
                1: [
                    { axis: "y", start: 7, finish: 8, side: "D", readonly: !1, calculate_with: "E", index: 3 },
                    { axis: "y", start: 11, finish: 12, side: "E", readonly: !1, calculate_with: "D", index: 3 },
                ],
                2: [{ axis: "x", start: 13, finish: 14, side: "F", readonly: !1, calculate_with: "", index: 3 }],
                3: [
                    { axis: "y", start: 15, finish: 0, side: "G", readonly: !1, calculate_with: "H", index: 3 },
                    { axis: "y", start: 3, finish: 4, side: "H", readonly: !1, calculate_with: "G", index: 3 },
                ],
            },
        },
    },
    tiles: {
        ids: { tiles: {}, edges: {}, corners: {} },
        colors: { tiles: {}, edges: {}, corners: {} },
        conf: { corners_diameter: 3 },
        colors_default: { "color-primary": "1", "color-secondary": "1", "color-custom": "1", "edges-color": "1", "corners-color": "1" },
        edges: {
            15.75: {
                no_available_color: [
                    "Ash Pine",
                    "Techno Green",
                    "Carnival Pink",
                    "Island Blue",
                    "Turf Green",
                    "Teal",
                    "Cosmic Purple",
                    "Ivory",
                    "Terra Cotta",
                    "Walnut Brown",
                    "Island Blue",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                ],
            },
            13: {
                no_available_color: [
                    "Pearl Grey",
                    "Island Blue",
                    "Techno Green",
                    "Teal",
                    "Royal Blue",
                    "Cosmic Purple",
                    "Carnival Pink",
                    "Ash Pine",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                ],
            },
        },
        corners: {
            15.75: {
                no_available_color: [
                    "Island Blue",
                    "Techno Green",
                    "Carnival Pink",
                    "Island Blue",
                    "Turf Green",
                    "Teal",
                    "Cosmic Purple",
                    "Ivory",
                    "Terra Cotta",
                    "Walnut Brown",
                    "Royal Blue",
                    "Ash Pine",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                ],
            },
            13: {
                no_available_color: [
                    "Pearl Grey",
                    "Island Blue",
                    "Techno Green",
                    "Teal",
                    "Royal Blue",
                    "Cosmic Purple",
                    "Carnival Pink",
                    "Ash Pine",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                ],
            },
        },
        types: {
            Vinyltrax: {
                display: siteURL + "vinyltrax_display.png",
                size: 15.75,
                desc: '15.75"',
                pattern: siteURL + "vinyltrax-Pattern.png",
                no_available_types: ["Floortrax", "Sportrax"],
                no_available_color: [
                    "Black Marble",
                    "Dark Oak",
                    "Canyon Slate",
                    "Diamond Plate",
                    "Pearl Grey",
                    "Pearl Silver",
                    "Slate Grey",
                    "Jet Black",
                    "Racing Red",
                    "Citrus Yellow",
                    "Terra Cotta",
                    "Tropical Orange",
                    "Chocolate Brown",
                    "Ivory",
                    "Mocha Java",
                    "Techno Green",
                    "Turf Green",
                    "Teal",
                    "Island Blue",
                    "Royal Blue",
                    "Cosmic Purple",
                    "Carnival Pink",
                    "Artic White",
                    "Royal Blue",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Medium Maple",
                    "Natural Pine",
                ],
                no_available_edges: [],
                no_available_corners: [],
            },
            Ribtrax: {
                display: siteURL + "ribtrax_display.png",
                size: 15.75,
                desc: '15.75"',
                pattern: siteURL + "custom-pattern.png",
                price: 4,
                no_available_types: ["Floortrax", "Sportrax"],
                no_available_color: [
                    "Ash Pine",
                    "Ivory",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                ],
                no_available_edges: [],
                no_available_corners: [],
            },
            "CUSTOM-RIB04": {
                display: siteURL + "btrirax_display.png",
                size: 15.75,
                desc: '15.75"',
                pattern: siteURL + "custom-pattern.png",
                price: 4,
                no_available_types: ["Floortrax", "Sportrax"],
                no_available_color: [
                    "Ash Pine",
                    "Island Blue",
                    "Pearl Grey",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Image Graphictrax",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                    "Turf Green",
                    "Terra Cotta",
                    "Techno Green",
                    "Teal",
                    "Ivory",
                    "Cosmic Purple",
                    "Carnival Pink",
                ],
                no_available_edges: [],
                no_available_corners: [],
            },
            Graphictrax: {
                display: siteURL + "graphictrax_display.png",
                size: 15.75,
                desc: '15.75"',
                pattern: siteURL + "graphictrax-Pattern.png",
                no_available_types: ["Floortrax", "Sportrax"],
                no_available_color: [
                    "Artic White",
                    "Pearl Grey",
                    "Pearl Silver",
                    "Slate Grey",
                    "Jet Black",
                    "Racing Red",
                    "Citrus Yellow",
                    "Terra Cotta",
                    "Tropical Orange",
                    "Chocolate Brown",
                    "Ivory",
                    "Mocha Java",
                    "Techno Green",
                    "Turf Green",
                    "Teal",
                    "Island Blue",
                    "Cosmic Purple",
                    "Carnival Pink",
                    "Ash Pine",
                    "Black Oak",
                    "Carbon Fiber",
                    "Dark Oak",
                    "Diamond Plate",
                    "Light Maple",
                    "Medium Maple",
                    "Natural Pine",
                    "Reclaimed Pine",
                    "Turftrax",
                    "Glossy Black",
                    "Glossy White",
                    "Black Carpet",
                    "Grey Carpet",
                    "Red Carpet",
                    "Canyon Slate",
                    "Black Marble",
                    "Polished Concrete",
                ],
                no_available_edges: [],
                no_available_corners: [],
            },
        },
    },
};
